"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReadycableImport = exports.ReadycableImportSchema = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const zod_1 = require("zod");
const ArticleType_1 = require("../ArticleType");
const ReadycableSchema_1 = require("../../generated/zod/modelSchema/ReadycableSchema");
const ReadycableCategorySchema_1 = require("../../generated/zod/inputTypeSchemas/ReadycableCategorySchema");
const Mantelwerkstoff_1 = require("../Mantelwerkstoff");
const VelocityUnitSchema_1 = require("../../generated/zod/inputTypeSchemas/VelocityUnitSchema");
const AccelerationUnitSchema_1 = require("../../generated/zod/inputTypeSchemas/AccelerationUnitSchema");
const LengthUnitSchema_1 = require("../../generated/zod/inputTypeSchemas/LengthUnitSchema");
const WeightPerLengthUnitSchema_1 = require("../../generated/zod/inputTypeSchemas/WeightPerLengthUnitSchema");
const checkMissingProps = (condition, props, value, msg, ctx) => {
    if (!condition) {
        return true;
    }
    const missingProps = props.filter((prop) => !value[prop]);
    if (!missingProps.length) {
        return true;
    }
    missingProps.forEach((prop) => {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: [prop],
            message: `missing although "${msg}" is set`,
            fatal: true,
        });
    });
    return false;
};
exports.ReadycableImportSchema = ReadycableSchema_1.ReadycableSchema.extend({
    articleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.leitung, { message: 'invalid ArticleType' }),
    // JSON fields => LocalizedText's
    artNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    categories: ReadycableCategorySchema_1.ReadycableCategorySchema.array().nonempty(),
    crossSection: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    description: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    connector1: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    connector2: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    outerJacket: zod_1.z.custom(Mantelwerkstoff_1.isMantelwerkstoff, { message: 'invalid Mantelwerkstoff' }),
    mainCategory: ReadycableCategorySchema_1.ReadycableCategorySchema,
    akeneoUuid: zod_1.z
        .string()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxUnsupportedUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxUnsupportedUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceUnsupportedUnit: LengthUnitSchema_1.LengthUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxGlidingUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxGlidingUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceGlidingUnit: LengthUnitSchema_1.LengthUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxVerticalUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxVerticalUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceVerticalUnit: LengthUnitSchema_1.LengthUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxUnsupported: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxUnsupported: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceUnsupported: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxGliding: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxGliding: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceGliding: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxVertical: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxVertical: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceVertical: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    copperWeightUnit: WeightPerLengthUnitSchema_1.WeightPerLengthUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    copperWeight: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    cableLength: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    cableLengthUnit: LengthUnitSchema_1.LengthUnitSchema.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
}).superRefine((value, ctx) => {
    const conditions = [
        {
            condition: value.unsupportedAllowed,
            props: [
                'accelerationMaxUnsupported',
                'accelerationMaxUnsupportedUnit',
                'speedMaxUnsupported',
                'speedMaxUnsupportedUnit',
                'travelDistanceUnsupported',
                'travelDistanceUnsupportedUnit',
            ],
            msg: 'unsupportedAllowed',
        },
        {
            condition: value.glidingAllowed,
            props: [
                'accelerationMaxGliding',
                'accelerationMaxGlidingUnit',
                'speedMaxGliding',
                'speedMaxGlidingUnit',
                'travelDistanceGliding',
                'travelDistanceGlidingUnit',
            ],
            msg: 'glidingAllowed',
        },
        {
            condition: value.verticalAllowed,
            props: [
                'accelerationMaxVertical',
                'accelerationMaxVerticalUnit',
                'speedMaxVertical',
                'speedMaxVerticalUnit',
                'travelDistanceVertical',
                'travelDistanceVerticalUnit',
            ],
            msg: 'verticalAllowed',
        },
    ];
    return conditions.every(({ condition, props, msg }) => checkMissingProps(condition, props, value, msg, ctx));
});
const isReadycableImport = (whatever) => {
    var _a;
    return (_a = exports.ReadycableImportSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isReadycableImport = isReadycableImport;
//# sourceMappingURL=ReadycableImport.js.map